import React from 'react';
import { Box, BoxProps, Flex } from 'rebass';
import Icon, { IconType } from '../Icon/Icon';
import './Timeline.styles.css';

export type BoxPropsFix = BoxProps & {
  css?: any;
};

export type TimelineItemRailProps = {
  isInitial?: boolean;
  isLast?: boolean;
  isFinal?: boolean;
  icon?: IconType;
  iconColor?: string;
  noDot?: boolean;
};

const TimelineItemRail = (props: TimelineItemRailProps) => {
  const {
    isInitial,
    isLast,
    isFinal = false,
    iconColor = '#000',
    icon,
    noDot,
  } = props;

  return (
    <Flex
      width={['10px', '10px', '10px', '20px']}
      mr={1}
      alignItems={'center'}
      flexDirection={'column'}
      flexShrink={0}
      className={isFinal ? 'history-rail is-final' : 'history-rail'} // use these to hook onto
    >
      {!noDot && (
        <Flex
          p="4px"
          alignItems={'center'}
          justifyContent={'center'}
          sx={{
            background: iconColor,
            position: 'relative',
            borderRadius: '50%',
            '*': {
              display: ['none', 'none', 'none', 'block'],
            },
          }}
        >
          {!icon && iconColor && <Box size="10px" />}
          {icon && <Icon icon={icon} color="white" size="10px" />}
        </Flex>
      )}
      <Box
        className="history-stroke-bottom"
        width="1px"
        flexGrow="1"
        flexShrink="1"
        sx={
          isFinal && isLast
            ? undefined
            : {
                borderLeft: '1px dashed black',
              }
        }
      />
    </Flex>
  );
};

export default TimelineItemRail;
